import * as CX from './Concept';

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_ACCESS = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_AGGREGATION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_ASSIGNMENT = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, '0'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_ASSOCIATION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_COMPOSITION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_FLOW = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_INFLUENCE = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_JUNCTION_AND = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'rvtfo'],
	[CX.APPLICATION_COMPONENT, 'rvtfo'],
	[CX.APPLICATION_EVENT, 'irvtfo'],
	[CX.APPLICATION_FUNCTION, 'irvtfo'],
	[CX.APPLICATION_INTERACTION, 'irvtfo'],
	[CX.APPLICATION_INTERFACE, 'rvtfo'],
	[CX.APPLICATION_PROCESS, 'irvtfo'],
	[CX.APPLICATION_SERVICE, 'irvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'rao'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_JUNCTION_OR = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_REALIZATION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_SERVING = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_SPECIALIZATION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_RELATIONSHIP_TRIGGERING = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'o'],
	[CX.MOTIVATION_CONSTRAINT, 'o'],
	[CX.MOTIVATION_DRIVER, 'o'],
	[CX.MOTIVATION_GOAL, 'o'],
	[CX.MOTIVATION_MEANING, 'o'],
	[CX.MOTIVATION_OUTCOME, 'o'],
	[CX.MOTIVATION_PRINCIPLE, 'o'],
	[CX.MOTIVATION_REQUIREMENT, 'o'],
	[CX.MOTIVATION_STAKEHOLDER, 'o'],
	[CX.MOTIVATION_VALUE, 'o'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'o'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'o'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'o'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'o'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, ''],
	[CX.RELATIONSHIP_JUNCTION_OR, ''],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);
